import 'core-js/stable'
import 'regenerator-runtime/runtime'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { i18n } from './i18n'
import './registerServiceWorker'
import './quasar'
import './styles/app.css'
import 'animate.css'
import inViewportDirective from 'vue-in-viewport-directive'
import VueTitle from '@/components/VueTitle'
Vue.directive('in-viewport', inViewportDirective)
Vue.component('vue-title', VueTitle)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
